import {defineStore} from 'pinia';
import Network from "~/utils/network";

const urls = {
    getFacebookPixelId: (financier) => `/api/administration/pixel/facebook/${financier}`,
};

export const usePixelStore = defineStore('pixel', {
    state: () => ({
        pixelId: null,
    }),
    actions: {
        fetchFacebookPixelId: async function (financier) {
            try {
                const data = await Network.http(urls.getFacebookPixelId(financier), {
                    method: 'GET',
                });
                this.pixelId = data;
            } catch (err) {
                console.log(err);
                await Promise.reject(err);
            }
        },
    },
    getters: {
        // pixelId(state) {
        //     return state.pixelId;
        // },
    },
});
